import { makeStyles } from "tss-react/mui";

export const useStyles = makeStyles()((theme) => ({
  container: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    width: "100%",
    borderTop: `1px solid ${theme.palette.divider}`,
    borderBottom: `1px solid ${theme.palette.divider}`,
    padding: theme.spacing(2.5, 0),
    [theme.breakpoints.up("lg")]: {
      padding: theme.spacing(4.5, 0.5),
    },
  },
  userDetailsContainer: {
    display: "flex",
    alignItems: "center",
    gap: theme.spacing(4),
  },
  userDetails: {
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    gap: theme.spacing(1),
    [theme.breakpoints.up("lg")]: {
      gap: theme.spacing(1.5),
    },
  },
  username: {
    fontSize: "0.63rem",
    fontWeight: 500,
    [theme.breakpoints.up("lg")]: {
      fontSize: "1rem",
    },
  },
  subscriptionType: {
    fontSize: "0.5rem",
    fontWeight: 500,
    color: theme.palette.secondary.main,
    textTransform: "uppercase",
    [theme.breakpoints.up("lg")]: {
      fontSize: "0.88rem",
    },
  },
  promotionalText: {
    fontSize: "0.63rem",
    fontWeight: 500,
  },
  signUpButton: {
    width: 135,
    height: 34,
    fontSize: "0.88rem",
    borderRadius: 5,
    [theme.breakpoints.up("lg")]: {
      width: 186,
      height: 46,
      fontSize: "1rem",
      borderRadius: 10,
    },
  },
}));
